export default __webpack_public_path__ + "static/media/energyAirFlowRight.0426bd52.svg";